export const CLOUDCHAT_ERROR = 'cloudchat:error';
export const CLOUDCHAT_ON_MESSAGE = 'cloudchat:on-message';
export const CLOUDCHAT_ON_START_CONVERSATION =
  'cloudchat:on-start-conversation';
export const CLOUDCHAT_READY = 'cloudchat:ready';
